import { FinalcutsPlayer } from 'components/app/finalcuts/finalcuts-player/finalcuts-player';
import { FinalcutsList } from 'components/app/finalcuts/finalcuts-list/finalcuts-list';
import { FcActions } from 'components/app/finalcuts/fc-actions/fc-actions';
import styles from './_app-layout.module.scss';

export const AppLayoutFc = () => {
  return (
    <div className={styles.Finalcuts}>
      <div className={styles.Finalcuts__videos}>
        <FinalcutsList />
      </div>
      <div className={styles.Finalcuts__actions}>
        <FcActions />
      </div>
      <div className={styles.Finalcuts__player}>
        <FinalcutsPlayer />
      </div>
    </div>
  );
};
